import { useSettings } from '@/hooks/useSettings'

export function StatsBar() {
  const { stats } = useSettings()
  const items = stats?.stats?.length ? stats.stats : [
    { value: '50k+', label: 'Bottles Shipped' },
    { value: '4.9★', label: 'Average Rating' },
    { value: '100%', label: 'Cruelty-Free' },
    { value: 'FSC', label: 'Packaging' },
  ]

  return (
    <section className="border-y border-line bg-paper py-16">
      <div className="mx-auto max-w-content px-6 lg:px-10">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          {items.map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="font-display text-3xl text-carbon">{stat.value}</p>
              <p className="mt-1 font-condensed text-xs uppercase tracking-[0.2em] text-carbon/60">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
